export enum OrganizationUnitType {
    PLANT = 'PLANT',
    OPERATION = 'OPERATION',
    AUTHORITY = 'AUTHORITY',
    OTHER = 'OTHER'
}
